<template>
  <vs-tabs>
    <vs-tab :label="getTabLabel(0)" @click="onClickTab(0)">
      <vx-card>
        <div>
          <div class="flex justify-between items-center">
            <p style="font-size: 18px; font-weight: 700">{{ getWorkplaceLabel() }} 등록</p>
            <div class="flex justify-end">
              <vs-button v-if="canDeleteField && !!postId" class="ml-4" color="secondary" type="border" @click="onClickDelete">삭제</vs-button>
              <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
              <vs-button class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
            </div>
          </div>
          <p class="title mt-5 mb-5">{{ getWorkplaceLabel() }} 개요</p>
          <div class="writeGridContainer">
            <div>
              <div>구분</div>
              <vs-select autocomplete v-model="form.meta.구분">
                <vs-select-item v-for="(data, index) in ['도급', '용역', '위탁']" :key="index" :text="data" :value="data" />
              </vs-select>
            </div>
            <div></div>
            <div></div>
            <div>
              <div>{{ getWorkplaceLabel() }}명(필수)</div>
              <ml-input v-model="form.field_name" />
            </div>
            <div>
              <div>담당 주무관</div>
              <ml-input v-model="form.manager_name" />
            </div>
            <div>
              <div>사업기간</div>
              <date-selector-rang :value="{ sDate: form.work_begin_at, eDate: form.work_end_at }" @sDate="form.work_begin_at = $event" @eDate="form.work_end_at = $event" />
            </div>

            <div>
              <div>사업금액(원)</div>
              <comma-input v-model="form.deposit_amount" />
            </div>
            <div>
              <div>{{ getWorkplaceLabel() }} 주소</div>
              <ml-input v-model="form.address" />
            </div>
            <div>
              <div>{{ getWorkplaceLabel() }} 연락처</div>
              <ml-input v-model="form.phone" placeholder="예) 055-123-4567" />
            </div>
          </div>
        </div>

        <!-- 담당 부서 및 수급업체 현황 -->
        <company-add-module
          v-model="companyList"
          :title="titles[0]"
          :detail-title="titles[1]"
          detail-label-com-name="부서(업체)명"
          :table-columns="[
            { head: '구분', key: 'com_type' },
            { head: '부서(업체)명', key: 'com_name' },
            { head: '대표자', key: 'com_ceo' },
            { head: '담당자', key: 'director' },
            { head: '연락처', key: 'phone' },
          ]"
          @remove="removeCompany"
        />

        <!-- 참여 인원 정보 -->
<!--        <company-user-auth-module-->
<!--          :colData="[-->
<!--            { head: '구분', key: 'company_id' },-->
<!--            { head: '사용자명', key: 'name' },-->
<!--            { head: '연락처', key: 'phone' },-->
<!--          ]"-->
<!--          :users="userList"-->
<!--          v-model="joinUsers"-->
<!--        />-->

        <div class="my-8" style="display: grid; grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
          <div>
            <p class="title-n">현장조감도</p>
            <file-uploader type="only-image" class="upload-img" v-model="form.field_view" />
          </div>
          <div>
            <p class="title-n">현장약도</p>
            <file-uploader type="only-image" class="upload-img" v-model="form.field_map" />
          </div>
          <div>
            <p class="title-n">현장사진</p>
            <file-uploader type="only-image" class="upload-img" v-model="form.field_photo" />
          </div>
        </div>

        <file-upload-module v-model="form.fileList" />
      </vx-card>
    </vs-tab>
    <vs-tab :label="getTabLabel(1)" @click="onClickTab(1)"></vs-tab>
  </vs-tabs>
</template>

<script>
import FileInput from "@/components/custom/FileInput";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FileUploader from "@/components/FileUploader";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import CompanyUserAuthModule from "@/views/_BS/components/CompanyUserAuthModule";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import DateSelector from "@/components/selector/DateSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import * as UiUtil from "@/util/UiUtil";
import { canDeleteField } from "@/util/FieldPermission";

export default {
  components: {
    DateSelector,
    SearchNavStartEnd,
    CompanyUserAuthModule,
    CompanyAddModule,
    FileUploader,
    FileInput,
    FileUploadModule,
    DateSelectorRang,
  },
  data() {
    return {
      form: {
        field_name: "", // 사업장명
        manager_name: "", // 담당 주무관
        deposit_amount: "", // 계약금액
        address: "", //주소
        work_begin_at: "", // 사업기간 시작
        work_end_at: "", // 사업기간 완료
        phone: "", // 대표번호
        company_ids: [], // 참여 업체 목록
        user_ids: [], // 참여 사용자 목록

        field_view: {}, // 현장 조감도
        field_map: {}, // 현장 약도
        field_photo: {}, // 현장 사진

        fileList: [],

        meta: {
          구분: "",
        }, // 부가 정보
      },
      companyList: [],
      userList: [],
      joinUsers: [],
    };
  },
  computed: {
    postId() {
      return this.$route.params.postId;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    canDeleteField() {
      return canDeleteField(this.$store, this.projectId);
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    titles(){
      if(this.projectId === '3') return ['담당부서 정보','업체정보'];
 else      return ['담당 부서(업체) 정보','부서(업체) 세부 정보'];
    }
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
  },
  created() {
    this.initBreadcrumb();
  },
  mounted() {
    if (this.postId) {
      this.loadField();
    }
  },
  methods: {
    initBreadcrumb() {
      if (parseInt(this.projectId) === 3) {
        this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "사업 현황" }, { title: "도급·용역·위탁 사업", active: true }]);
        return;
      }

      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: `${this.getWorkplaceLabel()} 현황` }, { title: "도급·용역·위탁 사업장", active: true }]);
    },
    async loadField() {
      const postId = this.postId;
      await this.$store.dispatch("project/LOAD_FIELD", { postId });
      const info = this.$store.state.project.fieldInfo;
      this.joinUsers = info.users;
      this.form = { ...info };

      if (this.form.meta) {
        this.form.meta = JSON.parse(info.meta);
      } else {
        this.form.meta = { 구분: "" };
      }

      if (this.form.field_map.length > 0) {
        this.form.field_map = this.form.field_map[0];
      } else {
        this.form.field_map = {};
      }
      if (this.form.field_photo.length > 0) {
        this.form.field_photo = this.form.field_photo[0];
      } else {
        this.form.field_photo = {};
      }
      if (this.form.field_view.length > 0) {
        this.form.field_view = this.form.field_view[0];
      } else {
        this.form.field_view = {};
      }

      if (this.form.companies && this.form.companies.length > 0) {
        const companies = [];
        for (const company of this.form.companies) {
          companies.push(company);
        }
        this.companyList = companies;

        await this.initMembers();
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },
    onClickTab(tabIndex) {
      if (tabIndex === 0) {
        this.$router.push({ name: "field-workplace2-list" });
      } else if (tabIndex === 1) {
        this.$router.push({ name: "field-workplace2-info" });
      }
    },
    onClickSave() {
      if (!`${this.form.field_name || ""}`.trim()) {
        UiUtil.alertDialog(`${this.getWorkplaceLabel()}명을 입력해 주세요.`);
        return;
      }
      const phone = `${this.form.phone || ""}`.trim();
      if (phone && !/^[0-9+()\-\s]+$/.test(phone)) {
        UiUtil.alertDialog(`${this.getWorkplaceLabel()} 연락처는 숫자와 하이픈(-)만 입력할 수 있습니다.`);
        return;
      }

      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      const user_ids = [];
      if (this.joinUsers.length > 0) {
        for (const user of this.joinUsers) {
          user_ids.push(user.id);
        }
      }
      this.form.company_ids = company_ids;
      this.form.user_ids = user_ids;
      this.form.project_id = this.$route.params.proj_id;

      if (this.postId) {
        // update
        const fieldId = this.postId;
        this.$store
          .dispatch("project/UPDATE_FIELD", {
            field_code: "workplace-subcontract",
            fieldId,
            ...this.form,
          })
          .then((/*value*/) => {
            this.$router.back();
          });
      } else {
        // create
        this.$store
          .dispatch("project/CREATE_FIELD", {
            field_code: "workplace-subcontract",
            ...this.form,
          })
          .then((/*value*/) => {
            this.$router.back();
          });
      }
    },
    async onClickDelete() {
      if (!(await UiUtil.confirmDialog("삭제하시겠습니까?"))) return;
      const fieldId = this.postId;
      this.$store
        .dispatch("project/DELETE_FIELD", {
          fieldId,
        })
        .then((/*value*/) => {
          this.$router.back();
        });
    },
    onClickMoveList() {
      this.$router.push({ name: "field-workplace2-list" });
    },
    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },
    handleSearch(/*searching*/) {},
    handleSort(/*key, active*/) {},

    getWorkplaceLabel() {
      let label = "사업장";
      if (parseInt(this.projectId) === 3) {
        label = "사업";
      }
      return label;
    },

    getTabLabel(index) {
      const label = this.getWorkplaceLabel();
      return `${label} ${index === 0 ? "등록" : "현황"}`;
    },
  },
};
</script>

<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
